<!-- 确认订单页面  Quick Buy-->

<template>
  <div class='car_box'>
    <div class="container">
      <div class="list_out_box">
        <div class="max_tt">Quick Buy</div>
        <div class="good_list_box">
          <div class="good_item_box" v-for="(item, index) in goodList" :key="index">
            <img :src="item.thumbnail" alt="" class="g_head">
            <div class="g_info_box">
              <div class="g_name">{{ item.name }}</div>
              <div class="g_attr">
                <p>Nicotine Content: <span>{{ goodsInfo.nicotineName }}</span></p>
                <p>Coil: <span>{{ goodsInfo.smokeType }}</span></p>
                <div class="num">X <span>{{ item.buyNum }}</span></div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- order -->
      <div class="order_out_box">
        <div class="mtt">Pay For The Order</div>
        <div class="line1_box">
          <span>Subtotal ({{ checkNum }} items)</span>
          <span class="val">${{ goodsPrice }}</span>
        </div>
        <div v-if="!isMiaosha" class="line1_box" @click="$refs.sCoupon.open(couponInfo.couponId)">
          <span>Select A Coupon</span>
          <p v-if="couponPrice">{{ couponPrice }}</p>
          <img v-else src="@/assets/images1/45.png" alt="" class="icon">
        </div>
        <div class="line1_box" v-if="!isMiaosha">
          <span>Discount</span>
          <span class="val">${{ discountPrice }}</span>
        </div>
        <div class="line1_box" style="margin-top: 24px;">
          <span>Total</span>
          <span class="val red">${{ payPrice }}</span>
        </div>
        <div class="border1" />
        <AddrItem v-model="addrId" @confirm="addrConfirm" />
        <!-- pay -->
        <div class="pay_box">
          <div class="mtt2" style="margin-top: 32px;">Select Payment Method
          </div>
          <div class="line3_box paypal" style="margin-top: 32px;" @click="cPayType = PAY_TYPE.PAY_PAL">
            <CmCheck :icon="payIcon" :activeIcon="payActiveIcon" disable :value="cPayType == PAY_TYPE.PAY_PAL" />
            <img src="@/assets/images1/53.png" alt="" class="icon1">
          </div>
          <div class="line3_box other_pay" @click="cPayType = PAY_TYPE.ON_DOWN">
            <CmCheck :icon="payIcon" :activeIcon="payActiveIcon" disable :value="cPayType == PAY_TYPE.ON_DOWN" />
            <span>Payment receipt</span>
          </div>
          <div v-if="cPayType == PAY_TYPE.ON_DOWN" class="upload_box">
            <div class="bg" v-loading="uploadLoading" @click="updateImg">
              <img v-if="payPicture" :src="payPicture" alt="">
              <img v-else src="@/assets/images1/54.png" alt="">
              <div v-if="payPicture" class="close" @click.stop="payPicture = ''">
                <el-icon name="close" />
              </div>
            </div>
            <div class="ulb_desc">Payment receipt</div>
          </div>
          <div class="btn_out_box">
            <div class="desc" style="cursor: pointer;" @click="$router.replace('/home/index')">Continue Shopping</div>
            <el-button class="btn" style="color: #fff!important;" :loading="toPayConfirmLoading"
              @click="toPayConfirmSubmitFn">Pay Now</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="Prompt" :visible.sync="isShowDelConfirmDialog" width="30%">
      <span>Are you sure to delete the currently selected product?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDelConfirmDialog = false" style="background-color: #fa14d533">Cancel</el-button>
        <el-button type="primary" @click="delSubmitFn" style="background-color: #fa14d5">Confirm</el-button>
      </span>
    </el-dialog>

    <!--  coupon  -->
    <coupon ref="sCoupon" @confirm="confirmCouponFn" />

  </div>
</template>

<script>
import AddrItem from './AddrItem.vue';
import CmCheck from './CmCheck.vue';
import Coupon from "@/views/home/car/Coupon.vue";
import { PAY_TYPE } from "@/const"

export default {
  components: { Coupon, CmCheck, AddrItem },
  data() {
    return {
      goodList: [],
      goodsInfo: {},
      couponIds: '',
      carID: [],
      PAY_TYPE,
      cPayType: "",
      isShowSelectCoupon: false,
      isShowDelConfirmDialog: false,
      demoNum: 1,
      isShowMore: false,
      payIcon: require("@/assets/images1/52.png"),
      payActiveIcon: require("@/assets/images1/51.png"),
      carLoading: false,
      carData: [],
      checkAll: false,
      delLoading: false,
      checkNum: 0, // 选中的商品数量
      goodsPrice: 0, // 商品价格
      discountPrice: 0, // 折扣金额
      couponPrice: 0, // 优惠券金额
      addrId: "", // 选中的地址ID
      couponInfo: {}, // 使用的优惠券数据
      toPayConfirmLoading: false,
      payPicture: "", // 支付图片
      addrInfo: {}, // 选中的地址信息
      uploadLoading: false,
      isMiaosha: true, // 是否为秒杀商品
    }
  },
  watch: {
    carData: {
      handler() {
        let allPrice = 0;
        this.checkNum = 0;
        this.carData.filter(item => {
          if (item.isCheck) {
            allPrice += (item.number * item.price || 0)
            this.checkNum += item.changeNumber
          }
        }).length;
        this.goodsPrice = allPrice;
      },
      deep: true
    }
  },
  computed: {
    // 需要支付的价格
    payPrice() {
      let price = this.goodsPrice - this.discountPrice - this.couponPrice;
      return price < 0 ? 0 : price;
    }
  },
  mounted() {
    this.goodsInfo = JSON.parse(sessionStorage.getItem("QUICK_BUY_DATA"));
    console.warn(this.goodsInfo, "goodsInfo")
    this.goodList = this.goodsInfo.falvorList || [];
    this.goodsPrice = this.goodsInfo.allPrice;
    this.isMiaosha = this.$route.query.ims == 1;
    this.checkNum = this.goodList.length;
    // if (localStorage.getItem("GOOD_num") == '1') {
    //   // 秒杀
    //   this.goodsPrice = Number(this.goodsInfo.price);
    // } else {

    // }

    // this.getcarFn();
    if (!this.isMiaosha) {
      this.getSettle();
    }

  },
  methods: {
    /** 结算信息 */
    async getSettle() {
      try {
        const res = await this.$post("system/orders/settle", {
          nicotineId: this.goodsInfo.nicotineId,
          goodsId: this.goodsInfo.goodsId,
          falvorList: this.goodsInfo.falvorList.map(item => {
            return { id: item.falvorId, number: item.buyNum }
          }),
          couponId: this.couponIds//优惠券id
        });
        this.discountPrice = res.data.discountsPrice
        // console.warn(res, "res")
      } catch (e) {
        this.$msg((e || {}).msg || "Fail", "e")
      }
    },

    demoFn() {
      this.$PUT("system/cart", {
        "cartId": 101,
        "number": -1000
      })
    },
    /** 上传支付凭证 */
    updateImg() {
      if (this.uploadLoading) return;
      const dom = document.createElement("input")
      dom.setAttribute("type", "file")
      dom.click();
      dom.onchange = async e => {
        const file = e.target.files[0];
        this.uploadLoading = true;
        try {
          const res = await this.$customUpload(file);
          this.payPicture = res.data.url || "";
        } catch (error) { this.$msg((error || {}).msg || "Fail") }
        this.uploadLoading = false;
      }

    },
    /** 购物车数量更新 */
    async numChangeFn(info) {
      if (info.numChangeLoading || info.changeNumber == info.number) return;
      info.numChangeLoading = true;
      try {
        await this.$PUT("system/cart", { cartId: info.cartId, number: info.changeNumber - info.number })
        info.number = info.changeNumber;
      } catch (e) {
        info.changeNumber = info.number;
      }
      info.numChangeLoading = false;
    },
    /** 选中地址 */
    addrConfirm(info = {}) {
      this.addrInfo = info;
    },
    /** 认证支付信息 */
    authenPayInfo() {
      let msg;
      if (!this.addrId) msg = "Please select a shipping address";
      else if (!this.cPayType) msg = "Please select payment method";
      else if (this.cPayType == PAY_TYPE.ON_DOWN && !this.payPicture) msg = "Please upload payment images";
      if (msg) this.$msg(msg, "e");
      return !msg;
    },
    /** 去支付 */
    async toPayConfirmSubmitFn() {
      console.warn(this.isMiaosha, this.goodsInfo, "this.isMiaosha")
      // return
      if (this.toPayConfirmLoading || !this.authenPayInfo()) return;
      this.toPayConfirmLoading = true;
      try {
        // console.debug(query,'query')
        if (!this.isMiaosha) {
          const query = {};
          query.goodsId = this.goodsInfo.goodsId;
          query.nicotineId = this.goodsInfo.nicotineId;
          query.falvorId = this.goodList.map(item => {
            return { id: item.falvorId, number: item.buyNum }
          });
          query.couponId = this.couponInfo.couponId || undefined;
          query.name = this.addrInfo.name;
          query.address = this.addrInfo.detail;
          query.payType = PAY_TYPE.PAY_PAL == this.cPayType ? 0 : 1;
          let res = await this.$post("system/orders/quickOrders", query);

          if (this.cPayType == PAY_TYPE.PAY_PAL) {
            if (res.data) window.open(res.data)
            else this.$msg("Invalid payment link")
          } else {
            res = await this.$post("system/orders/images", {
              ids: [res.data],
              images: this.payPicture,
            });
          }
          this.$router.replace("/home/orderList")
          this.$msg(res.msg || "succeed")
        } else {
          const query = {};
          query.number = this.goodsInfo.falvorList[0].buyNum;
          query.name = this.addrInfo.name;
          query.address = this.addrInfo.detail;
          query.payType = PAY_TYPE.PAY_PAL == this.cPayType ? 0 : 1;
          query.flashId = this.goodsInfo.flashId;
          let res = await this.$post("system/orders/flashOrders", query);

          if (this.cPayType == PAY_TYPE.PAY_PAL) {
            if (res.data) window.open(res.data)
            else this.$msg("Invalid payment link")
          } else {
            res = await this.$post("system/orders/images", {
              ids: [res.data],
              images: this.payPicture,
            });
          }
          this.$router.replace("/home/orderList")
          this.$msg(res.msg || "succeed")
        }

      } catch (e) {
        console.warn("e__", e)
        this.$msg((e || {}).msg || "fail", "e")
      }
      this.toPayConfirmLoading = false;
    },
    /** 选中优惠券 */
    confirmCouponFn(info) {
      this.couponInfo = info;
      this.couponIds = info.couponId;
      this.getSettle();
      console.warn(info, "info");
      // if (this.couponInfo.subtractPrice <= this.goodsPrice) {
      //   this.couponPrice = this.couponInfo.subtractPrice || 0;
      // } else {
      //   this.$message({
      //     message: 'Condition not satisfied',
      //     type: 'warning'
      //   });
      // }
      if (Number(this.couponInfo.subtractPrice) <= Number(this.goodsPrice)) {
        this.couponPrice = this.couponInfo.subtractPrice || 0;
      } else {
        this.$message({
          message: 'Condition not satisfied',
          type: 'warning'
        });
      }
      console.warn(this.goodsPrice, "goodsPrice")
    },
    /** 提交删除 */
    async delSubmitFn() {
      if (this.delLoading) return;

      this.delLoading = true;
      this.isShowDelConfirmDialog = false;

      const delArrData = [];
      const shengyuArrData = [];
      this.carData.map((item, index) => {
        if (item.isCheck) delArrData.push(item);
        else shengyuArrData.push(item)
      })
      this.carData = shengyuArrData;

      let delCountNum = 0;
      let apiFinallyNum = 0;
      delArrData.map(item => {
        delCountNum++;
        this.$DEL("system/cart/" + item.cartId).finally(err => {
          apiFinallyNum++;
          if (apiFinallyNum >= delCountNum) this.delLoading = false;
          this.$store.commit('setCarJsonJSON', this.carData);
        })
      })

    },
    /** 获取购物车数据 */
    async getcarFn() {
      this.carLoading = true;
      try {
        const res = await this.$get("system/cart/list", { pageSize: 1000 });
        this.carData = (res.rows || []).map(item => {
          return { ...item, isCheck: false, numChangeLoading: false, changeNumber: item.number, }
        })
      } catch (e) {
        this.$msg((e || {}).msg || "Fail", "e")
      }
      this.carLoading = false;
    },
    /** 删除购物车商品认证提示 */
    delCheckGoodAuthen() {
      if (this.delLoading) return;
      const resultArr = [];
      let maxNum = 0;
      this.carData.map(item => {
        if (item.isCheck) {
          if (maxNum < item.number) maxNum = item.number;
          resultArr.push(item.cartId)
        }
      })
      if (resultArr.length) this.isShowDelConfirmDialog = true;
      else this.$msg("Please select the shopping cart item that needs to be deleted", "e");
    },
    /** 改变单个选中 */
    changeItemCheckFn(info = {}) {
      info.isCheck = !info.isCheck;
      this.checkAll = this.carData.filter(item => item.isCheck).length == this.carData.length && this.carData.length;
      this.carID = [];
      this.carData.forEach(v => {
        if (v.isCheck) {
          this.carID.push(v.cartId)
        }
      });
      this.getSettle();
    },
    /** 改变选中全部 */
    changeCheckAllFn() {
      let result = !this.checkAll;
      this.carData.map(item => item.isCheck = result);
      this.checkAll = result;
      this.carID = [];
      this.carData.forEach(v => {
        if (v.isCheck) {
          this.carID.push(v.cartId)
        }
      });
      this.getSettle();
    },
  },
}
</script>

<style lang='scss' scoped>
@import './car.scss';

.good_list_box {
  margin-bottom: 52px;

  .good_item_box {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;

    &:last-of-type {
      margin-bottom: 0;
    }

    .g_head {
      margin-right: 16px;
      width: 84px;
      height: 84px;
      flex-shrink: 0;
    }

    .g_info_box {
      .g_name {
        margin-bottom: 8px;
        font-size: 16px;
        font-family: Inter, Inter-500;
        font-weight: 500;
        text-align: LEFT;
        color: #12181d;
      }

      .g_attr {
        margin-bottom: 4px;
        font-size: 14px;
        font-family: Inter, Inter-400;
        font-weight: 400;
        text-align: LEFT;
        color: #3f5566;
        line-height: 1.5;
      }

      .num {
        font-size: 14px;
        font-family: Inter, Inter-400;
        font-weight: 400;
        text-align: LEFT;
        color: #3f5566;
        margin-top: 8px;
      }
    }
  }
}
</style>
